import { render, staticRenderFns } from "./AddArticle.vue?vue&type=template&id=57802810&scoped=true&"
import script from "./AddArticle.vue?vue&type=script&lang=js&"
export * from "./AddArticle.vue?vue&type=script&lang=js&"
import style0 from "./AddArticle.vue?vue&type=style&index=0&id=57802810&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57802810",
  null
  
)

export default component.exports